export default class CategoriaStagionale{
    CodiceCategoria;
    Descr;
    UrlImmagine;
constructor(){}
}